$(document).ready(function($) {

   $.getScript("/source/js/functions.js");
    

    var editForm =  $("#name_form");
    var editDateOfBirth =  $("#date_of_birth_form");
    var editPhone = $("#phone_form");

    var currentLanguage = $("#lang").val();

    $(".edit-user-name").on("click", function (e) {
        var dataType = $(this).attr("data-type");

        var form = $("#" + dataType);
        var text = $("." + dataType);


        form.removeClass("hide");
        text.addClass("hide");

        e.preventDefault();
    })



    function success() {
        window.location.reload(true);
    }

    editForm.on("submit", function (e) {
        e.preventDefault();
        
        if(validate($(this)) == false)
            return;

        var first_name = $(this).find('.first_name').val();
        var last_name = $(this).find('.last_name').val();

        var text = $("." + $(this).attr("id"));

        text.find("h2").text(first_name + " " + last_name);

        $("#first_name").attr('value', first_name);
        $("#last_name").attr('value', last_name);

        $(this).addClass("hide");
        text.removeClass("hide");

        $.ajax({
            type: "POST",
            url: '/users/user-edit-profile/edit-name',
            data: {
                first_name: first_name,
                last_name: last_name,
                lang: currentLanguage
            },
            success: success
        });

    });



    editForm.on("reset", function (e) {
        var text = $("." + $(this).attr("id"));

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    });



    function hideBirthDateFromCV() {
        var is_hidden = $(document).find('.is_hidden');
        is_hidden.on('change', function() {

            if(is_hidden.is(':checked') == true)
            {
                // console.log(is_hidden);

                is_hidden.val(1);
            }
            else {
                is_hidden.val(0);
            }
        });

    }
    
    hideBirthDateFromCV();

    function hidePhoneFromCV() {
        var is_hidden_phone = $(document).find('.is_hidden_phone');

        is_hidden_phone.on('change', function() {

            if(is_hidden_phone.is(':checked') == true)
            {
                // console.log(is_hidden);

                is_hidden_phone.val(1);
            }
            else {
                is_hidden_phone.val(0);
            }
        });

    }

    hidePhoneFromCV();


    editDateOfBirth.on("submit", function (e) {
        hideBirthDateFromCV();

        e.preventDefault();
        if(validate($(this)) == false)
            return;

        var birth_day = $(this).find('.birth_day').val();
        var birth_month = $(this).find('.birth_month').val();
        var birth_year = $(this).find('.birth_year').val();
        var is_hidden_birth_date = $(this).find('.is_hidden').val();

        var text = $("." + $(this).attr("id"));


        text.find(".date_of_birth").text(getDate(birth_day, birth_month, birth_year));

        $(this).addClass("hide");
        text.removeClass("hide");

        $.ajax({
            type: "POST",
            url: '/users/user-edit-profile/edit-birth-date',
            data: {
                birth_day: birth_day,
                birth_month: birth_month,
                birth_year: birth_year,
                is_hidden: is_hidden_birth_date
            },
            success: success
        });

    });
    
    editPhone.on("submit", function(e) {
        hidePhoneFromCV();
        
        e.preventDefault();
        if(validate($(this)) == false)
            return;
        
        var phone = $(this).find('.phone').val();
        var is_hidden_phone = $(this).find('.is_hidden_phone').val();

        console.log(phone, is_hidden_phone);
        
        var text = $('.' + $(this).attr('id'));

        $(this).addClass("hide");
        text.removeClass("hide");

        $.ajax({
            type: "POST",
            url: '/users/user-edit-profile/edit-phone',
            data: {
                phone: phone,
                // birth_month: birth_month,
                // birth_year: birth_year,
                is_hidden_phone: is_hidden_phone
            },
            success: success
        });




    })



    editPhone.on('reset', function(e) {
        var text = $("." + $(this).attr("id"));

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    })

    editDateOfBirth.on("reset", function (e) {
        var text = $("." + $(this).attr("id"));

        $(this).addClass("hide");
        text.removeClass("hide");

        e.preventDefault();
    });


    function getDate(birth_day, birth_month, birth_year) {
        if(birth_day < 10)
            birth_day = "0" + birth_day;
        if(birth_month < 10)
            birth_month = "0" + birth_month;


        return birth_day + "." + birth_month + "." + birth_year;
    }
});

